<script setup>

import { Link }  from '@inertiajs/vue3';
import {scrollTop} from "@/utility";

// import Swiper core and required modules
import { Navigation, Pagination, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Swiper modules
const modules = [Navigation, Pagination, A11y, Autoplay];

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

var swiperInstance;

const onSwiper = (swiper) => {
	swiperInstance = swiper;
};

const slideTo = (index) => {
	swiperInstance.slideTo(index);
}

const props = defineProps({
	slider_uuid : {
		type: String,
		default: null
	}
});

const slides = ref([]);
const ready = ref(false);

import { onMounted, ref } from 'vue';

onMounted(() => {

	axios.get(route('slider.get', {uuid: props.slider_uuid}))
		.then(response => {
			slides.value = response.data;
			ready.value = true;
		})
		.catch(error => {
			console.log(error);
		});

});

const maxWidth = function(width) {
	return width === null ? null : `(max-width: ${width})`;
}

</script>

<template>
	<div v-if="ready">
		<swiper
			class="related-products-gallery"
			:autoplay="true"
			:modules="modules"
			:slides-per-view="1"
			:space-between="50"
			:pagination="{ clickable: true }"
			@swiper="onSwiper">

			<swiper-slide v-for="(slide, itemKey) in slides">

				<Link :href="slide.link" :title="slide.title" :preserveScroll="false" :onFinish="scrollTop">
					<picture>
						<source v-for="(variant, k) in slide.variants" :media="maxWidth(variant.max_width)" :srcset="variant.image">
						<img :src="slide.image" :alt="slide.title" class="w-100 h-auto">
					</picture>
				</Link>

			</swiper-slide>

		</swiper>
	</div>
	<div v-else class="d-flex justify-content-center align-middle w-100 proportional_padding">
		<div class="spinner-wrapper">
			<div class="spinner">
				<div class="bounce1"></div>
				<div class="bounce2"></div>
				<div class="bounce3"></div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "SwiperSlider",
}

</script>